/**
 * Logs the error to the monitoring system.
 * @param err
 * @param module
 * @param payload
 */
const logError = (err, { module = '', payload = {} } = {}) => {
    const error = err instanceof Error ? err : new Error(err);

    error.details = {
        payload,
        package: '@fiverr-private/payments',
        module,
    };

    setTimeout(() => {
        throw error;
    });
};

export const inClientContext = () => typeof window === 'object' && window.document;
export default logError;
